import { gql } from '@apollo/client';
import Fragments from './fragments';
export const ACCOUNT_STATEMENT_QUERY = gql`
  query accountStatement($configId: Int!) {
    accountStatement(configId: $configId) {
      ...accountStatementItem
      accountStatementIndicators {
        ...accountStatementIndicatorItem
      }
    }
  }
${Fragments.accountStatementItem}
${Fragments.accountStatementIndicatorItem}
`;

export const ACCOUNT_STATEMENT_DETAILS_QUERY = gql`
  query accountStatementDetails($pager: PagerInputNew, $filters: AccountStatementDetailsFilterInput, $configId: Int!) {
    accountStatementDetails(pager: $pager, filters: $filters, configId: $configId) {
      values {
        ...accountStatementDetailItem
      }
      total
    }
  }
${Fragments.accountStatementDetailItem}
`;

export const ACCOUNT_TYPES = gql`
  query dictionaryAccountTypes {
    dictionaryAccountTypes {
      id
      name
    }
  }
`;

export const BANKS_SEARCH = gql`
  query getPartnersSearchByUniqueIdAndTypeId($search: String, $partnerTypeId: Int) {
    getPartnersSearchByUniqueIdAndTypeId(search: $search, partnerTypeId: $partnerTypeId) {
      id
      uniqueId
      partnerName
    }
  }
`;
